import { atom } from 'jotai';

import type { DateRange } from '@/entities/query/types';
import type { PostFilterMap } from '../../../../entities/post/models';

export type OverrideAskSynclyFilter = {
  dateRange: DateRange | null;
  filter: PostFilterMap | null;
};

export const askSynclyFilterAtom = atom<OverrideAskSynclyFilter | null>(null);
